import * as React from "react";
import { StyleSheet, Text, View } from "react-native";
import { Button } from "./Button";
import { Card } from "./Card";

/** Shared preview screen used by both application entry points. */
export function HomeScreen(): React.JSX.Element {
  const [counter, setCounter] = React.useState(0);

  return (
    <View testID="home-screen">
      <Card title="Dashboard (preview)">
        <Text style={styles.text}>Interactive state shared across platforms.</Text>
        <Text style={styles.counter}>Count: {counter}</Text>
        <Button label="Increment" onPress={() => setCounter((c) => c + 1)} testID="increment" />
      </Card>
    </View>
  );
}

const styles = StyleSheet.create({
  text: {
    fontSize: 14,
    color: "#374151",
  },
  counter: {
    fontSize: 16,
    fontWeight: "600",
    color: "#111827",
  },
});

